import {IOfferFromJSON} from '../../../../types';
import {NO_PATTERN_BUSINESS_LOGIC, Price} from '@vfde-brix/core';

import {createPriceCompositionComponent, IPriceCompositionProperties} from '@vfde-brix/price-composition';
import {
    OFFER_CARD_PRICE_COMPOSITION_MONTHLY,
    OFFER_CARD_PRICE_COMPOSITION_ONETIME, PRICE_COMPOSITION_ICON,
} from 'Container/OfferDisplay/constant';
import {getFormattedFootnote} from 'Container/OfferDisplay/helpers/renderers/footnotesRenderHelper';
import {FeeType, ProductType} from 'Container/OfferDisplay/helpers/renderers/types';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * FIND STRUCTURE OF PRICE DETAILS IN readme.md
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

// Checks, if Element in JSON is empty. That means, there's no price composition to display
const isEmpty = (offer, productType: ProductType, feeType: FeeType) => {

    if ('monthly' === feeType ) {
        return ('' === offer[`${productType}_Product`] &&
            '' === offer[`${productType}_FN`] &&
            '' === offer[`${productType}_BigPrice`] &&
            '' === offer[`${productType}_Monthly_Subline`]
        );
    } else {
        return (
            '' === offer[`${productType}_Onetime`] &&
            '' === offer[`${productType}_Onetime_Subline`]
        );
    }
};

// Returns the headline of the price composition
const getHeadline = (productType: ProductType) => {
    switch (productType) {
        case 'Mobile':
            return 'Mobilfunk';
        case 'Fixed':
            return 'Internet & Festnetz';
        case 'TV':
            return 'TV';
        case 'RedPlus':
            return 'Partnerkarte';
    }
};

// Returns the headline of the price composition
const getPrice = (offer: IOfferFromJSON, productType: ProductType, feeType: FeeType) => {
    let price: Price;
    if ('monthly' === feeType ) {
        price = Price.fromString(offer[`${productType}_BigPrice`]);
    } else {
        price = Price.fromString(offer[`${productType}_Onetime`]);
    }

    return price.toString();
};

// Returns the headline of the price composition
const getSubline1 = (offer: IOfferFromJSON, productType: ProductType, feeType: FeeType) => {
    let subline;
    if ('monthly' === feeType ) {
        subline = offer[`${productType}_Product`] + getFormattedFootnote(offer[`${productType}_FN`]);
    } else {
        subline = offer[`${productType}_Onetime_Subline`];
    }

    return subline;
};

// Returns the headline of the price composition
const getSubline2 = (offer: IOfferFromJSON, productType: ProductType, feeType: FeeType) => {
    if ('monthly' === feeType ) {
        return offer[`${productType}_Monthly_Subline`];
    } else {
        return '';
    }
};

// Returns the headline of the price composition
const getPriceStyle = (feeType: FeeType) => {
    if ('monthly' === feeType ) {
        return 'bold';
    } else {
        return '';
    }
};

// Redners the price composition component
const renderPriceComposition = (element: HTMLElement, offer: IOfferFromJSON, feeType: FeeType, productType: ProductType) => {

    // If Element is not present in JSON, no Price-Compostion has to be displayed
    if (isEmpty(offer, productType, feeType)) {
        return;
    }

    const selector = 'monthly' === feeType ? OFFER_CARD_PRICE_COMPOSITION_MONTHLY : OFFER_CARD_PRICE_COMPOSITION_ONETIME;
    const priceCompositionContentDIV: HTMLElement = <HTMLElement> element.getElementsByClassName(selector)[0];
    const newDIV = document.createElement('div');

    const priceCompositionProperties: IPriceCompositionProperties = {
        stdHeadline: getHeadline(productType),
        stdPrice: getPrice(offer, productType, feeType),
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    if ('monthly' === feeType) {
        priceCompositionProperties.imgIconSrc = PRICE_COMPOSITION_ICON[productType];
    }

    // Subline 1
    const subline1 = getSubline1(offer, productType, feeType);
    if ('' !== subline1) {
        priceCompositionProperties.stdSubline1 = subline1;
    }

    // Subline2
    const subline2 = getSubline2(offer, productType, feeType);
    if ('' !== subline2) {
        priceCompositionProperties.stdSubline2 = subline2;
    } else {
        priceCompositionProperties.stdSubline2 = '&nbsp;';
    }

    // Price-Style
    const priceStyle = getPriceStyle(feeType);
    if ('' !== priceStyle) {
        priceCompositionProperties.optPriceStyle = priceStyle;
    }

    createPriceCompositionComponent(newDIV, priceCompositionProperties);
    priceCompositionContentDIV.append(newDIV);

};

/**
 * renders the multi divider dynamically
 * @param element
 * @param offer
 */
export const renderPriceCompositions = (element: HTMLElement, offer: IOfferFromJSON) => {

    // Creates Brix Component Price-Component
    renderPriceComposition(element, offer, 'monthly', 'Mobile');
    renderPriceComposition(element, offer, 'monthly', 'Fixed');
    renderPriceComposition(element, offer, 'monthly', 'TV');
    renderPriceComposition(element, offer, 'monthly', 'RedPlus');

    renderPriceComposition(element, offer, 'onetime', 'Mobile');
    renderPriceComposition(element, offer, 'onetime', 'Fixed');
    renderPriceComposition(element, offer, 'onetime', 'TV');
    renderPriceComposition(element, offer, 'onetime', 'RedPlus');

};
